import React, { useContext, useState, useEffect } from "react";
import { useSphereOneProvider } from "../../utils/SphereOneHooks";
import { Link, useLocation } from "react-router-dom";
import { Context } from "../../context/WalletContext";

export const MenuNoLogin = ({ itemLocation }) => {
  let location = useLocation();
  const { state } = useContext(Context);
  const [isExpanded, setIsExpanded] = useState(false);

  const { qorbiUserData } = useSphereOneProvider();

  function expandDropdownMenu() {
    setIsExpanded(!isExpanded);
  }

  return (
    <>
      <li className="nav-item dropdown">
        <Link
          className={`nav-link ${location.pathname === "/" ? "active" : ""}`}
          to="/"
        >
          Home
        </Link>
      </li>
      {itemLocation === "navbar" ? (
        <>
          <li className="nav-item dropdown">
            <Link
              className={`nav-link ${
                location.pathname === "/market" ? "active" : ""
              }`}
              to="/market"
            >
              Shop
            </Link>
          </li>
          {/* <li className="nav-item dropdown">
            <Link
              className={`nav-link ${
                location.pathname === "/marketplace" ? "active" : ""
              }`}
              to="/marketplace"
            >
              Qorbi Market
            </Link>
          </li> */}
       
          <li
            className="nav-item dropdown"
            onClick={() => {
              if (window.innerWidth >= 1000) {
                expandDropdownMenu();
              } else {
                window.location.href = "/my-assets";
              }
            }}
          >
            <Link
              className={`nav-link ${
                location.pathname === "/my-assets" ? "active" : ""
              }`}
              to={location.pathname}
            >
              Assets
            </Link>
            <ul
              className={`navbar-dropdown-menu ${isExpanded ? "expanded" : ""}`}
            >
              <li className="nav-item">
                <Link to="/my-assets" className={`nav-link`}>
                  Assets
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/bundles" className={`nav-link`}>
                  Bundles
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/skin-forge" className={`nav-link`}>
                  Forge
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/kitchen" className={`nav-link`}>
                  Burn Eggs
                </Link>
              </li>
            </ul>
          </li>
          {/* <li className="nav-item dropdown">
            <Link
              className={`nav-link ${
                location.pathname === "/training_quest" ? "active" : ""
              }`}
              to="/training_quest"
            >
              Training Quest
            </Link>
          </li> */}
        </>
      ) : (
        <>
          <li className="nav-item dropdown">
            <Link
              className={`nav-link ${
                location.pathname === "/pool" ? "active" : ""
              }`}
              to="/pool"
            >
              Qorb Pool
            </Link>
          </li>
          <li className="nav-item dropdown">
            <Link
              className={`nav-link ${
                location.pathname === "/games" ? "active" : ""
              }`}
              to="/market"
            >
              Games
            </Link>
          </li>
          <li className="nav-item dropdown">
            <a
              href="https://whitepaper.qorbiworld.com/"
              target="_blank"
              className={`nav-link ${
                location.pathname === "https://whitepaper.qorbiworld.com/"
                  ? "active"
                  : ""
              }`}
              rel="noreferrer"
            >
              White Paper
            </a>
          </li>
          {qorbiUserData?.testerGroup && (
            <li className="nav-item dropdown">
              <Link
                className={`nav-link ${
                  location.pathname === "/beta-tester" ? "active" : ""
                }`}
                to="/beta-tester"
              >
                Beta Testers
              </Link>
            </li>
          )}
        </>
      )}
      {state.marketplaceStatus && state.marketplaceStatus.mintEnable ? (
        <li className="nav-item dropdown">
          <Link
            className={`nav-link ${
              location.pathname === "/mint" ? "active" : ""
            }`}
            to="/mint"
          >
            Mint
          </Link>
        </li>
      ) : null}
    </>
  );
};
